/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Auth_Code_LedeInputs */

const en_us2_auth_code_lede = /** @type {(inputs: Auth_Code_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a 6-digit code to ${i?.email}. It's valid for a few minutes.`)
};

const pt_br2_auth_code_lede = /** @type {(inputs: Auth_Code_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviamos um código de 6 dígitos para ${i?.email}. Ele vale por poucos minutos.`)
};

const es_419_auth_code_lede = /** @type {(inputs: Auth_Code_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviamos un código de 6 dígitos a ${i?.email}. Vale por unos minutos.`)
};

const pt_pt2_auth_code_lede = /** @type {(inputs: Auth_Code_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviámos um código de 6 dígitos para ${i?.email}. É válido durante poucos minutos.`)
};

const fr_fr2_auth_code_lede = /** @type {(inputs: Auth_Code_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`On a envoyé un code à 6 chiffres à ${i?.email}. Il est valable quelques minutes.`)
};

const de_de2_auth_code_lede = /** @type {(inputs: Auth_Code_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben einen 6-stelligen Code an ${i?.email} geschickt. Er gilt ein paar Minuten.`)
};

const it_it2_auth_code_lede = /** @type {(inputs: Auth_Code_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abbiamo inviato un codice di 6 cifre a ${i?.email}. È valido per pochi minuti.`)
};

/**
* | output |
* | --- |
* | "We sent a 6-digit code to {email}. It's valid for a few minutes." |
*
* @param {Auth_Code_LedeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_lede = /** @type {((inputs: Auth_Code_LedeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_LedeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_lede(inputs)
	if (locale === "es-419") return es_419_auth_code_lede(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_lede(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_lede(inputs)
	if (locale === "de-DE") return de_de2_auth_code_lede(inputs)
	if (locale === "it-IT") return it_it2_auth_code_lede(inputs)
	return en_us2_auth_code_lede(inputs)
});
export { auth_code_lede as "auth.code_lede" }